import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DecorativeSideShapesComponent } from './decorative-side-shapes/decorative-side-shapes.component';
import { IfDesktopDirective } from './directives/if-desktop.directive';
import { IfMobileDirective } from './directives/if-mobile.directive';

@NgModule({
  declarations: [
    DecorativeSideShapesComponent,
    IfMobileDirective,
    IfDesktopDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    CommonModule,
    DecorativeSideShapesComponent,
    FormsModule,
    IfMobileDirective,
    IfDesktopDirective
  ]
})
export class SharedModule { }
